import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import {SwalAlertChoice, SwalAlertClass} from "core/swalClass";
import ButtonsActions from "views/utils/buttonsActions";
import {ProgrammingModel} from "site-apps/distribution/programming/ProgrammingModel";
import TopBarActions from "components/TopBarActions";
import TableProgramming from "./programming/TableProgramming";
import FormProgramming from "./programming/FormProgramming";
import PrevProgramming from "./programming/PrevPrograming";
import axiApi from "ApiCaller";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";
import ItemsModel from "core/itemsModel";

const ViewProgramming = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");
    const title = _Tr("labels.programming");
    const bread = [
        {name: _Tr("labels.route-management"), url: "/route-management", current: false},
        {name: _Tr("labels.programming"), current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const AlertQuestion = new SwalAlertChoice({
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
    });
    document.title = title;

    const items = useRef(new ItemsModel());
    const filters = useRef(new FilterModel());
    const pagerModelRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [buttonsTB, setButtonsTB] = useState({
        ...new ButtonsActions(),
        title: document.title,
    });
    const [itemsShow, setItemsShow] = useState([]);
    const [item, setItem] = useState({...ProgrammingModel});
    const [showForm, setShowForm] = useState(false);
    const [showPrev, setShowPrev] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [checkAll, setCheckAll] = useState(false);

    const headersTable = [
        {name: _Tt("common.name"), attr: 0, direction: "asc", active: true, default: true},
        {name: _Tt("common.description"), attr: 1, direction: "asc", active: false, disabled: true},
        {name: _Tt("common.type"), attr: 2, direction: "asc", active: false},
        {name: _Tt("common.start"), attr: 3, direction: "asc", active: false},
        {name: _Tt("common.end"), attr: 4, direction: "asc", active: false},
        {name: _Tt("common.compile"), attr: 5, direction: "asc", active: false},
        {name: _Tt("common.start_hour"), attr: 6, direction: "asc", active: false},
        {name: _Tt("common.repeat"), attr: 7, direction: "asc", active: false},
        {name: _Tt("common.between"), attr: 8, direction: "asc", active: false, disabled: true},
    ];

    useEffect(() => {
        const buttons = {...buttonsTB};
        buttons.title = document.title;
        buttons.add.active = true;
        buttons.add.onClick = onClickAdd;
        buttons.add.disabled = false;
        buttons.edit.active = true;
        buttons.edit.disabled = true;
        buttons.edit.onClick = onClickEdit;
        buttons.delete.active = true;
        buttons.delete.disabled = true;
        buttons.delete.onClick = onClickDelete;
        setButtonsTB(buttons);
        pagerModelRef.current.active = true;
        pagerModelRef.current.handleCallApi = () => {
            fetchProgrammings();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => fetchProgrammings();
        items.current.setItem = setItem;
        items.current.setShowPrev = setShowPrev;
        items.current.item = ProgrammingModel;
        fetchGetProgrammings();
    }, []);
    filters.current.filter = () => {
        pagerModelRef.current.paging.page = 1;
        fetchProgrammings();
    };

    const fetchGetProgrammings = () => {
        setIsLoading(true);
        axiApi
            .get("/api/distribution/programmings/")
            .then((resp) => {
                if (resp.data) {
                    items.current.showed = [...resp.data.items];
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const fetchProgrammings = () => {
        setIsLoading(true);
        axiApi
            .post("/api/distribution/programmings/", filters.current.chosen, {
                params: {...pagerModelRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                if (resp.data) {
                    items.current.setShowed(resp.data.items);
                    setItemsShow([...resp.data.items]);
                    if (resp.data.pager) {
                        pagerModelRef.current.paging.update(resp.data.pager);
                    }
                }
            })
            .catch((error) => {
                console.error("Error al enviar la solicitud:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const onClickAdd = () => {
        setItem({...ProgrammingModel});
        setShowForm(true);
    };
    const onClickEdit = () => {
        let selectedItem = items.current.showed.find((item) => item.id === items.current.chosen[0]);
        setItem({...selectedItem});
        setShowForm(true);
    };

    const onClickDelete = () => {
        AlertQuestion.fire("Se eliminaran", `Los ${items.current.checkBoxes.length} seleccionados`).then((r) => {
            setIsLoading(true);
            if (r.isConfirmed) {
                let ids = items.current.getChosenIds();
                setItem({...ProgrammingModel});

                axiApi
                    .delete("/api/distribution/programmings/", {data: {ids: ids}})
                    .then((r) => {
                        if (r.data.status) {
                            Alert.success("Confirmado", "Se han eliminado correctamente");
                            items.current.showed = items.current.showed.filter((_item) => !ids.includes(_item.id));
                            items.current.all = items.current.all.filter((_item) => !ids.includes(_item.id));
                            items.current.checkBoxes = [];
                            setItemsShow([...items.current.showed]);
                        } else {
                            r.data.message && console.info(r.data.message);
                            Alert.warning("Error en el servicio", "No se si se han podido eliminar las alertas");
                        }
                    })
                    .catch((err) => {
                        console.error(err);
                        if (err.response.status === 404) {
                            Alert.error("Error en el servidor", "El id enviado no esta accesible.");
                        } else {
                            Alert.error("Error en el servidor", "Consultar con el administrador.");
                        }
                    })
                    .finally(() => {
                        const buttons = {...buttonsTB};
                        buttons.edit.disabled = true;
                        buttons.delete.disabled = true;
                        items.current.clearChosen();
                        setButtonsTB(buttons);
                        setIsLoading(false);
                        setShowPrev(false);
                    });
            }
        });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <TopBarActions actions={buttonsTB} filtersRef={filters} />
            <TopBarPagination pagerModel={pagerModelRef.current} stickyTopValue="125px" chosen={items.current.chosen} />

            <div className="row">
                <div className="col-md col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <TableProgramming
                            items={items}
                            itemsShow={itemsShow}
                            buttonsTB={buttonsTB}
                            setButtonsTB={setButtonsTB}
                            checkAll={checkAll}
                            setCheckAll={setCheckAll}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
                {showPrev ? (
                    <div className="col-md col-12 prev-item" style={{maxWidth: "300px"}}>
                        <PrevProgramming show={showPrev} item={item} />
                    </div>
                ) : (
                    <></>
                )}
            </div>
            {showForm ? (
                <FormProgramming
                    show={showForm}
                    setShow={setShowForm}
                    item={item}
                    setItem={setItem}
                    items={items}
                    setItemsShow={setItemsShow}
                    fetchProgrammings={fetchProgrammings}
                />
            ) : (
                <></>
            )}
        </>
    );
};

export default ViewProgramming;
